import { FC } from 'react';
import { getPointsColor, getRoundedPercent, getRoundedPercentToWholeNumber } from 'utils/numbers';
import { declinationOfNumber } from 'utils/declination';
import { translate } from 'localizations';
import ScorePercent from './components/ScorePercent/ScorePercent';
import TooltipCustom from 'components/common/Tooltip/Tooltip';
import type { IOwnProps } from './types';
import { isNumber } from 'shared/lib/isNumber';

import styles from './styles.module.scss';

const CallScore: FC<IOwnProps> = ({ points, pointsPercent, dealPoints, dealPointsPercent, language }) => {
	const declinationArray: string[] = [
		translate('score_1', language),
		translate('score_24', language),
		translate('score_many', language),
	];

	const verifiedPoints = isNumber(points);
	const verifiedPointsPercent = isNumber(pointsPercent);
	const verifiedDealPoints = isNumber(dealPoints);
	const verifiedDealPointsPercent = isNumber(dealPointsPercent);

	const condition = verifiedPointsPercent ? getPointsColor(pointsPercent) : null;
	const conditionDeal = verifiedDealPointsPercent ? getPointsColor(dealPointsPercent) : null;

	const localPoints = verifiedPoints
		? `${getRoundedPercent(points)} ${declinationOfNumber(points, declinationArray)}`
		: null;

	const localPointsPercent = verifiedPointsPercent ? getRoundedPercentToWholeNumber(pointsPercent) : null;

	const localDealPoints = verifiedDealPoints
		? `${getRoundedPercent(dealPoints)} ${declinationOfNumber(dealPoints, declinationArray)}`
		: null;

	const localDealPointsPercent = verifiedDealPointsPercent ? getRoundedPercentToWholeNumber(dealPointsPercent) : null;

	return (
		<div className={styles.allScore}>
			{verifiedPoints && verifiedPointsPercent && (
				<div className={styles.callScoreWrapper}>
					<TooltipCustom
						background="dark"
						title={translate('checklists_points_result', language)}
						placement="top"
						followCursor={false}
					>
						{condition && <ScorePercent condition={condition} scorePercent={localPointsPercent} />}
						<div className={styles.callScore}>{localPoints}</div>
					</TooltipCustom>
				</div>
			)}
			{verifiedDealPoints && verifiedDealPointsPercent && (
				<div className={styles.callScoreWrapper}>
					<TooltipCustom
						background="dark"
						title={translate('checklists_points_deal_result', language)}
						placement="top"
						followCursor={false}
					>
						{conditionDeal && (
							<ScorePercent condition={conditionDeal} scorePercent={localDealPointsPercent} />
						)}
						<div className={styles.callScore}>{localDealPoints}</div>
					</TooltipCustom>
				</div>
			)}
		</div>
	);
};

export default CallScore;
